module.exports = __webpack_public_path__ + "static/media/kufangguanli1.a344477a.png";